import { py } from '@upgrade/react-components/Spacing/core';
import styled from 'styled-components';

export const StyledTrustPilotContainer = styled.div`
  overflow: hidden;
  ${py('md')}

  iframe {
    transform: scale(1.35);
  }

  @media (min-width: ${props => props.theme.mediaSm}) {
    iframe {
      transform: scale(2.25);
    }
  }
`;
